var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userInfo.businessGroup == '城矿')?_c('ChengKuangClaim'):_c('WuMaoClaim')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }